<template>
  <div class="eh-page">

    <!-- Hero -->
    <div class="eh-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-history</v-icon>
        </v-avatar>
        <div>
          <div class="eh-hero__title">Historial de modificaciones</div>
          <div class="eh-hero__sub">Auditoría de cambios en datos personales</div>
        </div>
      </div>
      <v-chip small color="rgba(255,255,255,0.15)" dark>
        <v-icon left small>mdi-shield-check-outline</v-icon> Auditoría
      </v-chip>
    </div>

    <div class="eh-body">
      <v-card outlined class="eh-table-card">

        <div class="eh-table-toolbar px-4 py-2 d-flex align-center" style="gap:8px;">
          <v-chip x-small :color="desserts.length ? 'indigo lighten-5' : 'grey lighten-3'"
            class="indigo--text text--darken-2 font-weight-medium">
            {{ desserts.length }} registro{{ desserts.length !== 1 ? 's' : '' }}
          </v-chip>
          <v-spacer />
          <v-progress-circular v-if="loading" indeterminate color="indigo" size="20" width="2" />
        </div>

        <v-divider />

        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="desserts"
          :items-per-page="5"
          loading-text="Cargando historial..."
          no-data-text="Sin registros de modificaciones."
          dense
          class="eh-table"
        >
          <!-- Modificaciones: tabla interna -->
          <template v-slot:[`item.data`]="{ item }">
            <table class="eh-inner-table" v-if="item.xcampos && item.xcampos.length">
              <thead>
                <tr>
                  <th>Campo</th>
                  <th>Valor anterior</th>
                  <th>Valor nuevo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(c, i) in item.xcampos" :key="i">
                  <td class="eh-field-name">{{ c.campo }}</td>
                  <td class="eh-old-val">{{ c.oldValue }}</td>
                  <td class="eh-new-val">{{ c.newValue }}</td>
                </tr>
              </tbody>
            </table>
            <span v-else class="grey--text text--lighten-1" style="font-size:0.78rem;">Sin detalle</span>
          </template>

          <!-- Método como chip -->
          <template v-slot:[`item.method`]="{ item }">
            <v-chip x-small label
              :color="methodColor(item.method)"
              class="font-weight-medium">
              {{ item.method }}
            </v-chip>
          </template>

        </v-data-table>
      </v-card>
    </div>

  </div>
</template>

<script>
import xaxios from '@/xaxios';

export default {
  data() {
    return {
      loading: false,
      user_id: null,
      headers: [
        { text: 'Fecha',          value: 'updated_at',  width: 160 },
        { text: 'Realizado por',  value: 'user',        width: 180 },
        { text: 'Contexto',       value: 'context',     width: 130 },
        { text: 'Tipo',           value: 'method',      width: 90 },
        { text: 'Modificaciones', value: 'data' },
      ],
      desserts: [],
    };
  },
  methods: {
    methodColor(method) {
      if (!method) return 'grey lighten-3';
      const m = method.toUpperCase();
      if (m === 'PUT' || m === 'PATCH') return 'orange lighten-4';
      if (m === 'POST')   return 'green lighten-5';
      if (m === 'DELETE') return 'red lighten-5';
      return 'indigo lighten-5';
    },
    async getHistorial() {
      this.desserts = [];
      this.loading = true;
      const url = process.env.VUE_APP_AUDIT + '/personas/id/' + this.user_id;
      const res = await xaxios.get(url);
      if (res && res.data) {
        res.data.forEach(x => {
          x.user = `${x.user_id} - ${x.name_user}`;
          window.console.log('>>>>', x.data);
          const fields = [];
          for (const outerKey in x.data) {
            if (x.data.hasOwnProperty(outerKey)) {
              const obj = { campo: outerKey };
              for (const innerKey in x.data[outerKey]) {
                if (x.data[outerKey].hasOwnProperty(innerKey)) {
                  obj[innerKey] = x.data[outerKey][innerKey];
                }
              }
              fields.push(obj);
            }
          }
          x.xcampos = fields;
        });
        this.desserts = res.data;
      }
      this.loading = false;
    },
  },
  mounted() {
    this.user_id = this.$route.query.id;
    if (this.user_id) this.getHistorial();
  },
};
</script>

<style scoped>
.eh-page { min-height: 100vh; background: #f5f7fa; }

.eh-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.eh-hero__title { font-size: 1.15rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.eh-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.eh-body { padding: 20px 24px; }

.eh-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.eh-table-toolbar { background: #fafbff; border-bottom: 1px solid #e8edf7; }

.eh-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.eh-table >>> tbody tr:hover { background: #f0f4ff !important; }
.eh-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 6px 12px !important;
  vertical-align: top;
}

/* Tabla interna de cambios */
.eh-inner-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.78rem;
  margin: 2px 0;
}
.eh-inner-table th {
  background: #e8edf7;
  color: #1a237e;
  font-weight: 700;
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 4px 8px;
  border: 1px solid #c5cae9;
  text-align: left;
}
.eh-inner-table td {
  padding: 4px 8px;
  border: 1px solid #e0e0e0;
  vertical-align: top;
}
.eh-field-name {
  color: #455a64;
  font-weight: 600;
  white-space: nowrap;
}
.eh-old-val { color: #b71c1c; background: #fff8f8; }
.eh-new-val { color: #1b5e20; background: #f1fff1; }
</style>
